export default "__VITE_ASSET__DFRM$F_r__"